var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import React, { useState } from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import TocStockHeader from "@frameworks/web/components/features/TOC/CommonTocComponent/TocHeader/TocStockHeader";
import SingleHeadingText from "@frameworks/web/components/features/TOC/CommonTocComponent/TocHeader/SingleHeadingText";
import Validity from "./Validity";
import { EMutualFundFlow } from "../MutualFund";
import { validityRadioEnum } from "../MutualFundConstant";
var CustomValidityData = function (props) {
    var device = DeviceContext();
    var _a = __read(useState(null), 2), errorTxt = _a[0], setErrorTxt = _a[1];
    var _b = __read(useState({
        presetValidity: validityRadioEnum.UNTIL_CANCELLED,
        customValidity: "",
    }), 2), validity = _b[0], setValidity = _b[1];
    var HandleApplyBtn = function () {
        if ((validity.presetValidity === validityRadioEnum.CUSTOME &&
            parseInt(validity.customValidity) < props.minInstallments) ||
            parseInt(validity.presetValidity) < props.minInstallments) {
            setErrorTxt("Number of installments should atleast be ".concat(props.minInstallments));
        }
        else {
            props.setPurchaseFormData(function (pData) {
                return __assign(__assign({}, pData), { sipValidationPreset: validity.presetValidity, sipValidationCustom: validity.customValidity });
            });
            props.setShow(EMutualFundFlow.PURCHASE);
        }
    };
    React.useEffect(function () {
        if (props.purchaseFormData) {
            setValidity({
                presetValidity: props.purchaseFormData.sipValidationPreset,
                customValidity: props.purchaseFormData.sipValidationCustom,
            });
        }
    }, [props.purchaseFormData]);
    return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Validity", closeFunction: function () {
                    props.setShow();
                } }) }),
        React.createElement("div", { className: "outer-body-section mf-validity mainScroll" },
            React.createElement(Validity, { validity: validity, setValidity: setValidity, setErrorTxt: setErrorTxt }),
            errorTxt && (React.createElement("div", { className: "text-danger taCenter DMSansNormal_12_400 pt-15" },
                React.createElement("span", null,
                    React.createElement("i", { className: "edel-icon-validation pe-1 align-middle" })),
                React.createElement("span", null, errorTxt)))),
        React.createElement("div", { className: "bottom-contents pe-3 ps-3  pb-2" },
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", disabled: (validity.presetValidity === validityRadioEnum.CUSTOME &&
                    !validity.customValidity) ||
                    errorTxt, onClick: function () { return HandleApplyBtn(); } })))) : (React.createElement(GenericDrawer, { show: props.show, setShow: props.setShow, headerComp: React.createElement(React.Fragment, null,
            React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Validity")), bodyComp: React.createElement(React.Fragment, null,
            React.createElement("div", { className: "outer-body-section overflow-scroll-300 iphone-scroll" },
                React.createElement(Validity, { validity: validity, setValidity: setValidity, setErrorTxt: setErrorTxt }),
                errorTxt && (React.createElement("div", { className: "text-danger taCenter DMSansNormal_12_400 pt-15" },
                    React.createElement("span", null,
                        React.createElement("i", { className: "edel-icon-validation pe-1 align-middle" })),
                    React.createElement("span", null, errorTxt)))),
            React.createElement("div", { className: "bottom-contents pe-3 ps-3 pb-3 pt-3 bg-white" },
                React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "w-100", disabled: (validity.presetValidity === validityRadioEnum.CUSTOME &&
                        !validity.customValidity) ||
                        errorTxt, onClick: function () { return HandleApplyBtn(); } }))) }))));
};
export default CustomValidityData;
